import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import img1 from "../Assets/requestDemo1.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { ColorRing } from "react-loader-spinner";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ContactService from "../Services/contact.service";

function RequestDemo({ showRequestDemo, setShowRequestDemo }) {
  const formRef = useRef(null);
  const [validated, setValidated] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const initialData = {
    name: "",
    phone: "",
    email: "",
    jobTitle: "",
    companySize: "",
    country: "",
    companyName: "",
    message: "",
  };
  const [details, setDetails] = useState(initialData);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = formRef.current;
    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("*Please fill all required fields!", {
        // position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }

    setLoading2(true);

    ContactService.submitRequestDemoData(details)
      .then((response) => {
        // console.log(response.data);
        
        // if (response.data === true) {
        //   handleShow();
        // }

        setLoading2(false);

        setDetails(initialData);

        toast.success("Submitted Successfully!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          onClose: () => setShowRequestDemo(false)
        });
        
        
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setShowRequestDemo(false);
      setIsExiting(false);
    }, 200);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  };

  const handleChangePhone = (e) => {
    setDetails({ ...details, phone: e });
  };
  return (
    <div>
      
      <Modal
        size="xl"
        show={showRequestDemo}
        onHide={handleClose}
        centered
        dialogClassName={
          isExiting
            ? "aaa reqDemo custom-modal-exit"
            : "aaa reqDemo custom-modal"
        }
      >
        <Modal.Body>
          <div className="row m-0">
            <div className="col-4 ps-0">
              <div className="text-end req-left-img">
                <img src={img1} alt="requestDemoFidus" />
              </div>
            </div>
            <div className="col-8 ps-0 pe-0">
              <div className="reqDemo-right">
                <div className="reqDemo-right-inner">
                  <ToastContainer />
                  {loading2 ? (
                    <>
                      <ColorRing
                        visible={true}
                        height="100"
                        width="100"
                        ariaLabel="color-ring-loading"
                        wrapperStyle={{}}
                        wrapperclassName="color-ring-wrapper"
                        colors={[
                          "#e15b64",
                          "#f47e60",
                          "#f8b26a",
                          "#abbd81",
                          "#849b87",
                        ]}
                      />
                      <h1>Loading... Please wait</h1>
                    </>
                  ) : (
                    <>
                      <div className="font-josefin contact-us-heading">
                        Request a Demo{" "}
                      </div>
                      <div className="font-jost text-start contactUs-subHead">
                        Reach out and we’ll get in touch within 24 hours.
                      </div>
                      <div className="mt-4 contact-us-form  font-jost">
                        <form
                          ref={formRef}
                          className={`row g-3 needs-validation ${
                            validated ? "was-validated" : ""
                          }`}
                          novalidate
                          onSubmit={handleSubmit}
                        >
                          <div className="col col-12 col-md-6 col-lg-6">
                            <label for="validationCustom01" className="form-label">
                              Name*
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              placeholder="Enter your full name"
                              name="name"
                              value={details.name}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6">
                            <label for="validationCustom03" className="form-label">
                              Phone Number*
                            </label>
                            <PhoneInput
                              country={"in"}
                              value={details.phone}
                              onChange={handleChangePhone}
                              inputProps={{
                                name: "phone",
                                required: true,
                                autoFocus: true,
                              }}
                              placeholder="Enter you phone number"
                            />
                            <div className="invalid-feedback">
                              Please provide a valid city.
                            </div>
                          </div>
                          <div className="col col-12 col-md-12 col-lg-12">
                            <label for="validationCustom02" className="form-label">
                              Email*
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="validationCustom02"
                              placeholder="Enter your Email"
                              name="email"
                              value={details.email}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6">
                            <label for="validationCustom01" className="form-label">
                              Job Title*
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              placeholder="Enter your job title"
                              name="jobTitle"
                              value={details.jobTitle}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6">
                            <label for="validationCustom03" className="form-label">
                              Company Size (No. of employees)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              placeholder="Enter you Company Size"
                              name="companySize"
                              value={details.companySize}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6">
                            <label for="validationCustom01" className="form-label">
                              Country
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              placeholder="Enter your country"
                              name="country"
                              value={details.country}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6">
                            <label for="validationCustom03" className="form-label">
                              Company Name*
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              placeholder="Enter you Company Name"
                              name="companyName"
                              value={details.companyName}
                              onChange={handleInputChange}
                              required
                            />
                          </div>

                          <div className="col col-12 col-md-12 col-lg-12">
                            <label for="validationCustom03" className="form-label">
                              Message
                            </label>
                            <textarea
                              className="form-control"
                              id="validationCustom03"
                              placeholder="Leave a message..."
                              name="message"
                              value={details.message}
                              onChange={handleInputChange}
                              rows={2}
                            />
                          </div>
                          <div className="col-12">
                            <button
                              className="contact-us-submit-btn  reqDemo-submit-btn"
                              type="submit"
                            >
                              Send Message
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RequestDemo;
